import Vue from 'vue';
import PackageClaimRedPacketRecords from './package-claim-redpacket-records.vue';

export default {
  showPackageClaimRedPacketRecords({ context = null, params, fontColor, pageSize, option } = {}) {
    return new Promise(() => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const PackageClaimRedRecordsCreator = Vue.extend(PackageClaimRedPacketRecords);

      const claimrecord = new PackageClaimRedRecordsCreator({
        el: document.createElement('div'),
        created() {
          this.params = params;
          this.fontColor = fontColor;
          this.pageSize = pageSize;
          this.option = option;

          this.$on('close', () => {
            if (!this.isMobile) {
              document.removeEventListener('click', () => ({}));
            }
            this.$destroy();
          });

          if (context) {
            // context 销毁的时候同时销毁自身
            context.$once('hook:beforeDestroy', () => this.$destroy());
          }
        },
        destroyed() {
          this.$el.remove();
        },
      });

      document.body.appendChild(claimrecord.$el);
    });
  },
};
